import React from "react";

import { useTranslation } from "react-i18next";

export function UserBusinessSavedSuccess() {
  const { t} = useTranslation('common');
  return (
    <div>
      <div>
        <h3 className="centersuccess">{t("success.businesssavedsuccess")}</h3>
      </div>
      <div className="centersuccess">
        <img src="/images/tick.png" alt="Tick" />
      </div>
      <hr></hr>
    </div>
  );
}
